import { AxiosError } from 'axios';

import { CLEAR_CACHE_API_URL } from '@/constants/apis';
import { configuration } from '@/constants/config';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

const clearCache = async (): Promise<
  ApiResponse<{ success: boolean; message: string; orgId?: string }>
> => {
  try {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    const response = await apiManager.delete(CLEAR_CACHE_API_URL, {
      baseURL: configuration.TERRITORIES_API_URL,
      headers,
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default clearCache;
